<template>
  <div class="siteDetection">
    <!-- 站点的menu列表开始 -->
    <div class="menuList">
      <div class="title">
        <Icon type="ios-keypad" />站点列表
      </div>
      <div class="menu">
        <ul>
          <li v-if="siteList.length == 0">暂无车间</li>
          <li v-for="item in siteList" :class="{ active: nowSite.id == item.id }" :key="item.id"
            @click="checkSite(item)">
            <div>
              <span class="iconfont icon-xingzhuang"></span>
              {{ item.name }}
            </div>
            <Icon type="ios-radio-button-on" :style="{ color: item.color }" />
          </li>
        </ul>
      </div>
    </div>
    <!-- 站点的menu列表结束 -->

    <!-- 站点图开始 -->
    <div class="site_image" ref="siteImgBox">
      <div class="img_relative" ref="siteImgSize" @mousemove="mouseMove($event)" @mouseup="isMouseDown = false">
        <!-- 工艺图 -->

        <img :src="'http://ks.wodiantech.cn'+nowSite.imgUrl" @dragstart.prevent @load="siteImgLoad" ref="siteImg" alt />
        <img src="@/assets/bigScreen/00002.png" v-if="!nowSite.imgUrl" alt />
        <!-- 箭头 -->
        <div class="arrow_list" v-for="item in arrowVectorList" :key="item.id" :style="{
          top: item.axis_y + 'px',
          left: item.axis_x + 'px',
          width: item.direction === 'up' || item.direction === 'down' ? '32px' : 'auto',
          height: item.direction === 'up' || item.direction === 'down' ? 'auto' : '32px'
        }" :class="{
          'topanima': item.direction === 'up',
          'leftanima': item.direction === 'left',
          'buttomanima': item.direction === 'down',
          'rightanima': item.direction === 'right'
        }">
          <img src="@/assets/top.png" v-if="item.direction === 'up'" alt="">
          <img src="@/assets/left.png" v-if="item.direction === 'left'" alt="">
          <img src="@/assets/down.png" v-if="item.direction === 'down'" alt="">
          <img src="@/assets/right.png" v-if="item.direction === 'right'" alt="">
        </div>
        <!-- 设备图 -->
        <div class="device_img" :ref="'device_img_' + item.id" v-for="item in deviceList" :style="{
          top: item.top,
          left: item.left,
          width: item.statusImg ? item.width : 'auto',
          height: item.statusImg ? item.height : 'auto',
          'cursor': isEdit ? 'move' : 'pointer'
        }" :key="item.id" @click="openAiModal($event, item)" @mousemove="showAiDiv(item)" @mouseout="hideAiDiv(item)"
          @mousedown="mouseDown($event, item)" @mouseup="mouseUp($event, item)">
          <!-- 有图设备 -->
          <img :src="'http://ks.wodiantech.cn'+item.statusImg" v-if="item.statusImg" @dragstart.prevent alt class="deviceImgDom" />
          <!-- 文字设备 -->
          <div v-if="!item.statusImg && ((nowSite.id == 8 && findDeviceTypeCodeById(item.mold) != '液位:') || nowSite.id != 8)" style="padding: 0.45em; border-radius: 0.25em" class="textOverflow no_img">
            <Icon type="ios-radio-button-on" :style="{ color: item.statusColor }" />
            {{ findDeviceTypeCodeById(item.mold) }}
            <span style="color: yellow;">{{ (item.thanSign) }}{{ item.siteDeviceAi }}</span>
            {{ (" " + item.unit || "无") }}
          </div>
          <!-- 污水处理站 液位动画 -->
          <div v-if="!item.statusImg && nowSite.id == 8 && findDeviceTypeCodeById(item.mold) == '液位:'" class="waterAni no_img">
            <div class="waterBox" :style="{width:item.width,height:item.height}">
              <div class="wave" :style="{'height':getWaterHeight(item)+'%'}">
                <img src="@/assets/wave.png" class="waveImg" alt="">
              </div>
            </div>
            <div class="info">
              <Icon type="ios-radio-button-on" :style="{ color: item.statusColor }" />
            {{ findDeviceTypeCodeById(item.mold) }}
            <span style="color: yellow;">{{ (item.thanSign) }}{{ item.siteDeviceAi }}</span>
            {{ (" " + item.unit || "无") }}
            </div>
          </div>
          <div class="item_details" :style="{
            top: item.maskTop,
            left: item.maskLeft,
            transform: `translate(${item.maskTx},${item.maskTy})`,
          }" v-if="showAiId == item.id">
            <div class="item_text">
              <span>设备名：</span>
              <span>{{ item.name }}</span>
            </div>
            <div class="item_text">
              <span>监测值：</span>
              <span>{{ (item.thanSign) }}{{ item.siteDeviceAi || "无" }}</span>
            </div>
            <div class="item_text" v-if="item.statusLsit">
              <span>当前状态：</span>
              <span v-for="(jtem, index) in item.statusLsit" :key="index" style="margin: 0 4px">{{ jtem }}</span>
            </div>
            <div class="item_text">
              <span>时间：</span>
              <span>{{ item.createAgo || "无" }}</span>
            </div>
          </div>
        </div>

        <!-- 活性炭 -->
        <div class="activated_charcoal" v-for="item in activatedCharcoal" :style="{
          top: item.top + 'px',
          left: item.left + 'px',
          width: item.width + 'px',
          height: item.height + 'px',
        }" @mousemove="showACDiv(item)" @mouseout="hideACDiv(item)" :key="item.id">
          <img src="@/assets/ac/green.png" v-if="item.remainVolume * 100 > 80" alt="正常" />
          <img src="@/assets/ac/yellow.png" v-else-if="item.remainVolume * 100 > 50" alt="预警" />
          <img src="@/assets/ac/orange.png" v-else-if="item.remainVolume * 100 > 30" alt="告警" />
          <img src="@/assets/ac/red.png" v-else-if="item.remainVolume >= 0" alt="立即更换" />
          <div class="item_details" :style="{
            top: item.top,
            left: item.left,
            transform: `translate(${item.maskTx},${item.maskTy})`,
          }" v-if="showACId == item.id">
            <div class="item_text">
              <span>设备名：</span>
              <span>{{ item.remark }}</span>
            </div>
            <div class="item_text">
              <span>剩余吸附量：</span>
              <span>{{ jsMul(item.remainVolume, 100) + "%" || "无" }}</span>
            </div>
            <div class="item_text">
              <span>总去除量：</span>
              <span>{{ item.vOCsVolume + "g" || "无" }}</span>
            </div>
            <div class="item_text" v-if="item.statusLsit">
              <span>当前状态：</span>
              <span v-for="(jtem, index) in item.statusLsit" :key="index" style="margin: 0 4px">{{ jtem }}</span>
            </div>
            <div class="item_text">
              <span>更换日期：</span>
              <span>{{ item.reloadTime || "无" }}</span>
            </div>
          </div>
        </div>
      </div>
      <Spin fix v-if="loading.imgLoad"></Spin>
    </div>

    <!-- 查看10条数据对话框 -->
    <Modal title="监测值历史" v-model="modal.AiShow" style="text-align: center" :mask-closable="false" width="1200">
      <div class="AiModal_content">
        <div class="search" style="text-align: left;padding-left: 20px;">
          时间范围：
          <DatePicker type="daterange" split-panels placeholder="选择日期" @on-change="dateChange($event)"
            style="width: 200px">
          </DatePicker>
        </div>
        <div class="valueChart" ref="valueChartRef"></div>
        <div v-if="modal.AiTenData == 0">暂无监测值数据</div>
        <Spin fix v-if="modal.loading"></Spin>
      </div>
      <div slot="footer"></div>
    </Modal>

    <!-- 站点图结束 -->

    <!-- 信息通知栏开始 -->
    <div class="formation">
      <!-- 告警信息 -->
      <div class="site_warn formation_item">
        <div class="title" style="position: relative;">
          <span class="iconfont icon-icon-"></span>
          异常信息列表
          <span class="tag" style="padding: 0 10px;background: red;border-radius: 10px;font-size: 12px;">{{
            warnModular.data.length }}</span>
          <span style="color: #fff;cursor: pointer;position: absolute;right: 10px;top: 0;"
            @click="showList = !showList">{{ showList ? "收起" : "展开" }}</span>
        </div>
        <div class="warn_list" v-show="showList">
          <ul>
            <li v-if="!warnModular.data || warnModular.data.length == 0">
              暂无异常信息
            </li>
            <li v-for="item in warnModular.data" @mouseover="warnOver($event)" @mouseout="warnOut($event)"
              :key="item.id">
              <div class="status_icon">
                <div class="circle" :style="{ background: item.color }"></div>
              </div>
              <a href="javascript:void(0);" :title="mergedContent(item)" class="text textOverflow">{{ mergedContent(item) }}</a>
              <div class="time_ago textOverflow">{{ item.timeAgo }}</div>
            </li>
          </ul>
          <Spin fix v-if="loading.warnLoad"></Spin>
        </div>
      </div>
      <!-- 设备模块 -->
      <!-- <div class="device_list formation_item">
        <div class="title">
          <span class="iconfont icon-shebeileixing"></span>
          站点设备列表
        </div>
        <div class="device">
          <ul>
            <li v-if="deviceList.length == 0" style="
                border-bottom: 1px solid #ccc;
                padding: 0.5em 0.625em;
                text-align: left;
              ">
              站点暂无设备
            </li>
            <li v-for="item in deviceList" :key="item.id">
              <div class="device_box" :style="{ background: item.statusColor }">
                <div class="device_name textOverflow">
                  <span class="iconfont icon-shebeixinghao"></span>
                  {{ item.name }}
                </div>
                <div class="device_value">
                  {{ item.siteDeviceAi || "暂无" }}
                </div>
              </div>
            </li>
          </ul>
          <Spin fix v-if="loading.deviceLoad"></Spin>
        </div>
      </div> -->
    </div>
    <!-- 信息通知栏结束 -->
  </div>
</template>

<style lang="scss" scoped>
.siteDetection {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  background-color: #1f305b;
  color: #fff;
  position: relative;

  .menuList {
    width: 14.5em;
    // border-right: 1px solid #ccc;
    z-index: 888;
    overflow: auto;
    background: #003970;

    .title {
      padding: 0.625em 0 0.625em 1em;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // border-bottom: 1px solid #ccc;
      // background: rgb(226, 219, 219);

      i {
        font-size: 1.125em;
        margin-right: 0.25em;
      }
    }

    .menu {
      ul {
        li {
          padding: 0.625em 1em 0.625em 1em;
          color: #fff;
          cursor: pointer;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        li:hover {

          background-image: linear-gradient(90deg, #3FC1FF 0%, #008EFF 100%);
          color: #fff;
        }

        .active {
          // background-color: rgb(185, 185, 185);
          background-image: linear-gradient(90deg, #3FC1FF 0%, #008EFF 100%);
          color: #fff;
          // box-shadow: 0 0 8px #ccc;
        }
      }
    }
  }

  .site_image {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: relative;

    .img_relative {
      width: auto;
      height: auto;
      position: relative;

      // border: 1px solid black;
      img {
        width: 100%;
      }

      .arrow_list {
        position: absolute;
      }

      .topanima {
        animation: anitop 1s linear infinite;
      }

      .leftanima {
        animation: anileft 1s linear infinite;
      }

      .buttomanima {
        animation: anibottom 1s linear infinite;
      }

      .rightanima {
        animation: aniright 1s linear infinite;
      }

      .device_img {
        position: absolute;
        user-select: none;

        .deviceImgDom {
          user-select: none;
        }
        .waterAni{
          .waterBox{
            background: white;
            // border-radius: 30px;
            position: relative;
            overflow: hidden;
          .wave{
            width: 200%;
            background: rgba(#24EDF0,1);
            // background: radial-gradient(#387343,#2A6837);
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: flex-start;
            animation: wave 2s infinite linear;
            opacity: 0.8;
            // transform: rotate(0deg) translateY(3px);
            .waveImg{
              width: 100%;
              bottom: 100%;
              position: absolute;
            }
          }
          @keyframes wave {
            0%{
              transform: translateX(0) translateY(2px);
            }
            100%{
              transform: translateX(-50%) translateY(0px);
            }
          }
          }
          // @keyframes wave {
          //   0%{
          //     transform: rotate(0deg) translateY(2px);
          //   }
          //   25%{
          //     transform: rotate(15deg) translateY(0px);
          //   }
          //   50%{
          //     transform: rotate(0deg) translateY(2px);
          //   }
          //   75%{
          //     transform: rotate(-15deg) translateY(0px);
          //   }
          //   100%{
          //     transform: rotate(0deg) translateY(2px);
          //   }
          // }
        }
        .no_img {
          // background: rgba(0, 0, 0, 0.8);
          color: #fff;
          font-size: 1em;
          display: flex;
          align-items: center;

          i {
            padding: 0 0.25em;
            color: red;
          }
        }

        .item_details {
          background: rgba(0, 0, 0, 0.6);
          padding: 0.45em;
          color: #ffffff;
          border-radius: 0.25em;
          position: absolute;
          top: 100%;
          left: 100%;
          transform: translate(0, 0);
          width: auto;
          height: auto;
          z-index: 888;

          .item_text {
            display: flex;

            span {
              font-size: 0.875em;
              white-space: nowrap;
            }
          }
        }

        .item_status {
          position: absolute;
          top: 230%;
          left: -100%;
          width: 3vw;
          height: auto;
          z-index: 888;
          background-color: #1aa15f;
          color: white;
        }
      }

      .activated_charcoal {
        position: absolute;
        cursor: pointer;

        .item_details {
          background: rgba(0, 0, 0, 0.8);
          padding: 0.45em;
          color: #fff;
          border-radius: 0.25em;
          position: absolute;
          top: 100%;
          left: 100%;
          transform: translate(0, 0);
          width: auto;
          height: auto;
          z-index: 999;

          .item_text {
            display: flex;

            span {
              font-size: 0.875em;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .formation {
    width: 20%;
    padding: 0.5em;
    position: absolute;
    right: 0;
    top: 0;

    .site_warn {
      height: 50%;
      margin-bottom: 0.5em;

      .warn_list {
        height: calc(100% - 2.8125em);
        width: 100%;
        position: relative;
        background: #003970;
        border-radius: 6px;

        ul {
          width: 100%;
          height: 100%;
          overflow: auto;

          li {
            display: flex;
            padding: 0.5em 0.625em;
            cursor: pointer;
            // border-bottom: 1px solid #ccc;

            .status_icon {
              width: 1em;
              position: relative;

              .circle {
                width: 0.5em;
                height: 0.5em;
                border-radius: 50%;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
              }
            }

            a {
              color: #fff;
            }

            .text {
              flex: 1;
              text-align: left;
            }

            .time_ago {
              color: #fff;
            }
          }

          li:hover {
            // background-color: #ccc;
            background-image: linear-gradient(90deg, #3FC1FF 0%, #008EFF 100%);
          }
        }
      }
    }

    .device_list {
      height: calc(50% - 0.5em);

      .device {
        height: calc(100% - 2.8125em);
        width: 100%;
        position: relative;

        background: #003970;
        border-radius: 6px;

        ul {
          height: 100%;
          overflow: auto;
          padding: 1rem;

          li {
            padding: 0.25em;

            .device_box {
              border-radius: 0.25em;
              background: #ccc;
              color: #fff;
              padding: 0.5em;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
        }
      }
    }

    .formation_item {
      width: 100%;
      // border: 0.0625em solid #ccc;
      // box-shadow: 0 0 0.25em #888;
      border-radius: 0.25em;
      overflow: hidden;

      .title {
        padding: 0 0.625em;
        height: 2.8125em;
        line-height: 2.8125em;
        text-align: left;
        // background-color: rgb(208, 221, 210);
        // color: #28b56a;
        background: #00488D;
        color: #fff;
      }
    }
  }
}

.AiModal_content {
  position: relative;

  .valueChart {
    width: 100%;
    height: 300px;
  }

  .ai_item {
    .ai_data {
      margin-bottom: 16px;
      padding: 0.25em 1em;
      background-color: #18a05e;
      color: #fff;
      font-size: 1.25em;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 0.25em;
    }
  }
}

@keyframes anitop {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-20px);
  }
}

@keyframes anileft {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-20px);
  }
}

@keyframes anibottom {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(20px);
  }
}

@keyframes aniright {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(20px);
  }
}
</style>

<script>
import { timeStamp, timeLength } from "../../../util/common/date";
import { MyWebSocket } from "../../../util/common/socket/socket";
import echarts from 'echarts';
import { BaseUrl } from '@/http/config.js'

export default {
  data() {
    return {
      showList: false,
      checkDevice: {},
      // 站点列表
      siteList: [],
      // 设备列表
      deviceList: [],
      //活性炭设备
      activatedCharcoal: [],
      ac_height: "", //活性炭显示计算相对位置用的
      // 移入活性炭显示遮罩
      showACId: null,
      // 当前的站点数据
      nowSite: {
        mn: null,
        id: null,
        imgUrl: null,
      },
      // 告警信息模块
      warnModular: {
        data: [],
        pageCurrent: 1,
      },
      // 加载开关列表
      loading: {
        imgLoad: true, // 控制图片loading
        warnLoad: true, // 控制告警信息loading
        deviceLoad: true, // 设备列表loading
      },
      // 缩放比例
      scaleRadio: null,
      // 对话框属性
      modal: {
        AiShow: false,
        AiTenData: [], // 最新十条电流值
        loading: true,
      },
      // 移入设备显示遮罩
      showAiId: null,
      // 长链接
      socket: null,
      maxAiName: "",
      arrowVectorList: [],
      deviceTypeList: [], // 设备类型枚举
      isMouseDown: false,//鼠标是否按下
      mouseDownInfo: "",
      moveItem: "",//移动的dom
      isMove: false,//判断当前dom是否移动用于阻止click事件
      isEdit: false,//是否可移动dom
    };
  },
  components: {
  },
  beforeRouteLeave(to, from, next) {
    if (this.socket) {
      this.socket.close();
    }
    next();
  },

  created() {
    this.isEdit = parseInt(this.$route.query.edit)
    let siteMn = this.$route.query.siteMn;
    let siteId = this.$route.query.siteId;
    this.nowSite.mn = siteMn || null;
    this.nowSite.id = siteId || null;
    this.getDeviceType();
    this.pageResize();
  },
  methods: {
    getWaterHeight(item){
      let siteDeviceAi = parseFloat(item.siteDeviceAi)
      let limitValue = parseFloat(item.limitValue)
      if(!siteDeviceAi || !limitValue){
        return 0
      }
      return (siteDeviceAi/limitValue) * 100
    },
    mouseDown(event, item) {
      if (!this.isEdit) {
        return
      }
      this.mouseDownInfo = event
      this.isMouseDown = true
      this.moveItem = item
      document.body.onmouseup = () => {
        this.isMouseDown = false
      }
    },
    mouseUp(event, item) {
      if (!this.isEdit) {
        return
      }
      this.isMouseDown = false
      if (this.mouseDownInfo.clientX == event.clientX && this.mouseDownInfo.clientY == event.clientY) {
        this.isMove = false
        return
      }
      //需要将XY还原至原比例
      let form = {
        id: item.id,
        imgUrlX: item.imgUrlX, // 设备图片定位X
        imgUrlY: item.imgUrlY, // 设备图片定位Y
      }
      this.$api.Deploy.postDeviceEdit({ content: form }, [
        "uuid",
        "company"
      ]).then(res => {
        if (res.code == 0) {
          this.$Message.success("位置更新成功")
          // this.getDeviceList()
          // this.$Notice.success({
          //   title: "更新成功",
          //   desc: "更新成功，正在刷新数据..."
          // });
          // this.modal.show = false;
          // this.getData();
        } else {
          // this.$Notice.warning({
          //   title: "更新失败",
          //   desc: res.message || "请联系管理员"
          // });
        }
      });
      setTimeout(() => {
        this.isMove = false
      }, 10)
    },
    mouseMove(event) {
      if (!this.isEdit) {
        return
      }
      if (this.isMouseDown) {
        let leftX = event.movementX
        let leftY = event.movementY
        let imgW = this.$refs.siteImgSize.clientWidth; // 图片宽度
        let imgH = this.$refs.siteImgSize.clientHeight; // 图片高度
        let dom = this.$refs['device_img_' + this.moveItem.id][0]
        let itemW = 0
        let itemH = 0
        if (dom) {
          itemW = dom.clientWidth //dom宽度
          itemH = dom.clientHeight //dom高度
        }
        this.deviceList.forEach(item => {
          if (item.id == this.moveItem.id) {
            let left = parseFloat(item.left) + leftX
            let top = parseFloat(item.top) + leftY
            if (left < 0) {
              left = 0
            }
            if (left > imgW - itemW) {
              left = imgW - itemW
            }
            if (top < 0) {
              top = 0
            }
            if (top > imgH - itemH) {
              top = imgH - itemH
            }
            item.left = left + "px"
            item.top = top + "px"
            item.imgUrlX = left / this.scaleRadio
            item.imgUrlY = top / this.scaleRadio
            this.isMove = true
          }
        })
      }

    },
    dateChange(date) {
      //console.log(val)
      this.checkDevice.startDate = date[0];
      this.checkDevice.endDate = date[1];
      this.getDeviceApi();
    },
    // 页面数据初始化
    pageResize: async function () {
      await this.getSiteEnum(); // 获取站点列表数据
      this.getWarnList(); // 获取站点告警列表
      await this.getDeviceList(); // 获取站点设备
      await this.getDeviceTypeImage(); // 获取设备类型及状态对应设备图片
      await this.getExtConsumerRecord(); // 获取最新电流值
      await this.getActivatedCharcoal(); // 获取活性炭设备信息
      this.webSocket();
    },
    // 获取站点枚举值
    getSiteEnum() {
      return new Promise((resolve, reject) => {
        this.$api.Deploy.getSiteList({ paging: false }, [
          "uuid",
          "company",
        ]).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            for (let i = 0, length = data.length; i < length; i++) {
              switch (parseInt(data[i].status)) {
                case 16: {
                  data[i].color = "#FFD700";
                  break;
                }
                case 1: {
                  data[i].color = "#00d56e";
                  break;
                }
                case 128: {
                  data[i].color = "#FFD700";
                  break;
                }
                case 4: {
                  data[i].color = "#2C2C2C";
                  break;
                }
                case 32: {
                  data[i].color = "#ce41b9";
                  break;
                }
                default: {
                  data[i].color = "#dd4f42";
                }
              }
            }
            this.siteList = data;
            if (this.siteList.length == 0) {
              // 说明没有站点
              this.loading.warnLoad = false;
              this.loading.imgLoad = false;
              this.loading.deviceLoad = false;
              reject();
              return;
            }
            if (data.length != 0 && !this.nowSite.id) {
              // 默认站点
              if (!this.$route.query.siteId) {
                this.nowSite.mn = data[0].mn;
                this.nowSite.id = data[0].id;
              }
              this.nowSite.imgUrl = data[0].imgUrl;
              console.log(this.nowSite.imgUrl)
            } else {
              data.map((res) => {
                if (res.id == this.nowSite.id) {
                  if (!this.$route.query.siteId) {
                    this.nowSite.id = data[0].id;
                  }
                  this.nowSite.imgUrl = res.imgUrl;
                  console.log(this.nowSite.imgUrl)
                }
              });
            }
            resolve();
          } else {
            this.$Notice.warning({
              title: "获取站点枚举失败",
              desc: res.message || "请联系管理员",
            });
          }
        });
      });
    },
    // 获取设备列表
    getDeviceList() {
      this.arrowVectorList = [];
      return new Promise((resolve, reject) => {
        this.$api.Deploy.getDeviceList(
          { content: { mn: this.nowSite.mn }, paging: false },
          ["uuid", "company"]
        )
          .then((res) => {
            if (res.code == 0) {
              this.loading.deviceLoad = false; //加载完成
              let data = res.data;
              // 遮罩适配
              let width = this.$refs.siteImgBox.clientWidth; // 容器宽
              let height = this.$refs.siteImgBox.clientHeight; // 容器高
              let imgH = this.$refs.siteImgSize.clientHeight; // 图片高度
              // console.log(width, height, data);
              for (let i = 0; i < data.length; i++) {
                // 四个值top left tx ty
                data[i].maskLeft = "100%";
                data[i].maskTx = "0";
                data[i].maskTop = "100%";
                data[i].maskTy = "0";
                if (parseInt(data[i].imgUrlX) + 200 > width) {
                  // 当x坐标加上遮罩距离超过容器时 换遮罩方向向左
                  data[i].maskLeft = "0";
                  data[i].maskTx = "-100%";
                }
                if (
                  parseInt(data[i].imgUrlY) + (width - imgH) / 2 + 200 >
                  height
                ) {
                  // y坐标加遮罩高度大于容器高度时 遮罩方向换为向上
                  data[i].maskTop = "0";
                  data[i].maskTy = "-100%";
                }
                switch (data[i].status) {
                  case "告警": {
                    data[i].color = "#dc4d41";
                    break;
                  }
                  case "正常": {
                    data[i].color = "#17a05d";
                    break;
                  }
                  default: {
                    data[i].color = "#888";
                  }
                }
                // 加入箭头
                if (data[i].arrowVector) {
                  let arrowVector = JSON.parse(data[i].arrowVector);
                  for (let j = 0; j < arrowVector.length; j++) {
                    this.arrowVectorList.push(arrowVector[j]);
                  }
                }
              }
              this.deviceList = data;
              resolve();
            } else {
              this.$Notice.warning({
                title: "获取站点设备失败",
                desc: res.message || "请联系管理员",
              });
            }
          })
          .catch((err) => {
            this.loading.deviceLoad = false; //加载完成
          });
      });
    },
    // 获取设备类型及状态对应设备图片
    getDeviceTypeImage() {
      return new Promise((resolve, reject) => {
        this.$api.Deploy.getDeviceTypeImage(null, ["uuid", "company"]).then(
          (res) => {
            if (res.code == 0) {
              let deviceList = this.deviceList;
              let data = res.data;
              deviceList.map((res, index) => {
                data.map((prop) => {
                  if (res.mold == prop.deviceType) {
                    this.$set(
                      this.deviceList[index],
                      "deviceStateImageList",
                      prop.deviceStateImageList
                    );
                    if (
                      prop.deviceStateImageList &&
                      typeof prop.deviceStateImageList == "object"
                    ) {
                      let imgDefault = prop.deviceStateImageList.filter(
                        (res1) => {
                          return res1.states == res.status;
                        }
                      );
                      if (!imgDefault[0]) {
                        let url = prop.deviceStateImageList[0].url
                        this.$set(
                          this.deviceList[index],
                          "statusImg",
                          url
                        );
                      } else {
                        let url = imgDefault[0].url
                        this.$set(
                          this.deviceList[index],
                          "statusImg",
                          url
                        );
                      }
                    }
                  }
                });
              });
              resolve();
            } else {
              this.$Notice.warning({
                title: "获取设备类型状态图失败",
                desc: res.message || "请联系管理员",
              });
            }
          }
        );
      });
    },
    // 获取设备最新电流值
    getExtConsumerRecord() {
      return new Promise((resolve, reject) => {
        this.$api.Report.getExtConsumerRecord(
          { content: { siteMn: this.nowSite.mn }, pageSize: 22 },
          ["uuid", "company"]
        ).then((res) => {
          if (res.code == 0) {
            // 给设备列表加上电流值
            let deviceList = this.deviceList; // 设备列表

            let data = res.data; // 电流值列表
            let maxAi = 0;
            // 第一层遍历device 循环设备
            deviceList.map((device, index) => {
              // 第二层遍历prop 循环设备电流值siteDeviceAi
              data.map((prop) => {
                if (device.id == prop.siteDeviceId) {
                  // 给设备加上电流值
                  this.$set(
                    this.deviceList[index],
                    "siteDeviceAi",
                    (prop.siteDeviceAi !== undefined) ? prop.siteDeviceAi.toFixed(2) : null
                  );
                  // 给设备加上电流值最新时间
                  this.$set(
                    this.deviceList[index],
                    "createAgo",
                    timeLength(prop.createDate)
                  );
                  this.$set(
                    this.deviceList[index],
                    "createDateNew",
                    prop.createDate
                  );
                  // 设置设备状态
                  let color = null;
                  prop.siteDeviceState = parseInt(prop.siteDeviceState);
                  switch (prop.siteDeviceState) {
                    case 16: {
                      color = "#FFD700";
                      break;
                    }
                    case 1: {
                      color = "#1aa15f";
                      break;
                    }
                    // 停机
                    case 4: {
                      color = "#888";
                      break;
                    }
                    // 断电
                    case 32: {
                      color = "#742c69";
                      break;
                    }
                    default: {
                      if ((prop.siteDeviceState & 128) == 128) {
                        color = "#ffd11b";
                      } else {
                        color = "#dc4d41";
                      }
                    }
                  }
                  this.$set(this.deviceList[index], "statusColor", color);
                  this.$set(this.deviceList[index], "thanSign", (prop.thanSign == undefined || prop.thanSign == null) ? '' : prop.thanSign);
                  this.$set(
                    this.deviceList[index],
                    "statusLsit",
                    prop.siteDeviceStateNames
                  );
                  // 给设备加上状态图 可能不存在该值 说明设备已文本显示
                  if (
                    device.deviceStateImageList &&
                    typeof device.deviceStateImageList == "object"
                  ) {
                    let defaultImg = null;
                    this.deviceList[index].statusImg = null;
                    device.deviceStateImageList.map((msg) => {
                      // 第三层遍历msg 循环遍历设备类型图statusImg
                      // 可能没有对应状态的图片 默认用告警
                      // console.log(msg.states, prop.siteDeviceState)
                      if (msg.states == prop.siteDeviceState) {
                        this.$set(this.deviceList[index], "statusImg", msg.url);
                      }
                      if (msg.states == 2) {
                        // 告警的那张图片
                        defaultImg = msg.url;
                      }
                    });

                    // 遍历循环后还是没有图片 说明没有对应状态图待补充 默认显示告警
                    if (!this.deviceList[index].statusImg) {
                      this.$set(
                        this.deviceList[index],
                        "statusImg",
                        defaultImg
                      );
                    }
                  }
                }
              });
            });
            resolve();
            // console.log(this.deviceList);
          } else {
            this.$Notice.warning({
              title: "获取最新监测值失败",
              desc: res.message || "请联系管理员",
            });
          }
        });
      });
    },
    /**
     * 排序 告警设备显示优先级
     */
    warnSort(data) {
      const sort = { 告警: 0, 正常: 1, 断电: 2 };
      data.sort((a, b) => {
        return sort[a.status] - sort[b.status];
      });
      return data;
    },
    // 选择站点切换页面
    checkSite: async function (parmas) {
      // 初始化
      this.deviceList = []; // 清空设备列表
      this.warnModular.data = []; // 清空告警信息列表
      this.loading.imgLoad = true; // 开启工艺图loading
      this.loading.deviceLoad = true; //开启设备laoding
      this.loading.warnLoad = true; //开启设备laoding
      this.nowSite = parmas; // 站点信息更换
      this.$router.push({
        // 路由记录页面
        path: "/chome/siteDetection",
        query: {
          siteMn: parmas.mn,
          siteId: parmas.id,
          date: new Date().getTime(),
        },
      });
      this.getWarnList(); // 获取告警信息列表
      await this.getDeviceList(); // 获取设备设备
      await this.getActivatedCharcoal(); // 获取活性炭设备信息
      let siteMn = this.nowSite.mn;
      let topic = {
        siteDeviceState: {
          siteMn: siteMn,
        },
      };

      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.siteMn = siteMn;
        this.socket.send("subscrip", topic);
      }
      this.devicePosition();
      await this.getDeviceTypeImage(); // 获取设备类型及状态对应设备图片
      this.getExtConsumerRecord(); // 获取最新电流值 电流值获取必须要先获取设备
    },
    // 获取设备类型枚举
    getDeviceType() {
      this.$api.Enum.getDeviceTypeEnum(
        { content: { tableName: "site_device", columnName: "type" } },
        ["uuid", "common"]
      ).then(res => {
        if (res.code == 0) {
          this.deviceTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取设备类型枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    findDeviceTypeCodeById(sid) {
      const item = this.deviceTypeList.find(item => parseInt(item.key) === parseInt(sid));
      let res = "";
      if (item) {
        if (item.value !== "纯数字")
          res = item.value + ":";
      }
      return res
    },
    // 获取告警列表
    getWarnList() {
      this.$api.Warn.getWarnDataList(
        {
          content: { siteId: this.nowSite.id || this.siteList[0].id },
          // pageCurrent: this.warnModular.pageCurrent,
          paging: false,
        },
        ["uuid", "company"]
      )
        .then((res) => {
          if (res.code == 0) {
            this.loading.warnLoad = false; // 关闭告警loading
            let data = res.data;
            for (let i = 0, length = data.length; i < length; i++) {
              // contentType == 8为预警
              let ss = data[i].contentTypeName;
              if (ss.indexOf("预警") >= 0) {
                data[i].color = "#FFD700";
              } else if (ss.indexOf("断电") >= 0) {
                data[i].color = "#742c69";
              } else if (ss.indexOf("运维") >= 0) {
                data[i].color = "#ffd11b";
              } else {
                data[i].color = "#dc4d41";
              }
              data[i].timeAgo = timeLength(data[i].startDate);
            }

            this.warnModular.data = data.filter((res) => {
              return !res.isExpire;
            });
          } else {
            this.$Notice.warning({
              title: "获取告警信息失败",
              desc: res.message || "请联系管理员",
            });
          }
        })
        .catch((err) => {
          this.loading.warnLoad = false; // 关闭告警loading
        });
    },
    // 图片加载完毕
    siteImgLoad() {
      if (this.$route.path != "/chome/siteDetection") {
        // 当路由发生变化 去除事件监听
        window.removeEventListener("resize", this.siteImgLoad);
        return false;
      }
      // 容器
      let Bwidth = this.$refs.siteImgBox.clientWidth;
      let Bheight = this.$refs.siteImgBox.clientHeight;
      // 原图
      let imgWidth = this.$refs.siteImg.naturalWidth;
      let imgHeight = this.$refs.siteImg.naturalHeight;

      /**
       * 如果imgWidth = Bwidth；
       * imgWidth/imgHeight=比例
       * 设imgWidth缩小或放大为Bwidth
       * 那么imgHeight为Bwidth除比例 当imgHeight大于Bheight时说明容器放不下 换一种方式
       * 设imgHeight为Bheight则imgWidth为比例乘Bheight
       */
      let radio = imgWidth / imgHeight;
      let w = Bwidth;
      let h = Bwidth / radio;
      if (h > Bheight) {
        h = Bheight;
        w = radio * Bheight;
      }
      // 容器宽高
      this.$refs.siteImgSize.style.width = w + "px";
      this.$refs.siteImgSize.style.height = h + "px";
      this.scaleRadio = w / imgWidth; // 缩放比例
      this.devicePosition();

      window.addEventListener("resize", this.siteImgLoad); // 添加页面尺寸变化响应
    },
    // 对设备位置进行计算
    devicePosition() {
      if (this.loading.deviceLoad) {
        setTimeout(() => {
          this.devicePosition();
        }, 1000);
        return false;
      }
      let deviceList = this.deviceList;
      let activatedCharcoal = this.activatedCharcoal;

      deviceList.map((res, index) => {
        let top = res.imgUrlY * this.scaleRadio + "px";
        let left = res.imgUrlX * this.scaleRadio + "px";
        let width = res.imgUrlWidth * this.scaleRadio + "px";
        let height = res.imgUrlHeight * this.scaleRadio + "px";
        this.$set(this.deviceList[index], "top", top);
        this.$set(this.deviceList[index], "left", left);
        this.$set(this.deviceList[index], "width", width);
        this.$set(this.deviceList[index], "height", height);

        activatedCharcoal.map((res_sub, index_sub) => {
          if (res.id == res_sub.siteDeviceId) {
            this.$set(this.activatedCharcoal[index_sub], "top", parseInt(res_sub.locationY) * this.scaleRadio);
            this.$set(this.activatedCharcoal[index_sub], "left", parseInt(res_sub.locationX) * this.scaleRadio);
            this.$set(this.activatedCharcoal[index_sub], "width", 171 * this.scaleRadio);
            this.$set(this.activatedCharcoal[index_sub], "height", 70 * this.scaleRadio);
          }
        });
      });
      this.loading.imgLoad = false; // 关闭遮罩loading
    },
    // 点击设备显示电流值列表
    openAiModal(event, obj) {
      if (this.isMove) {
        return
      }
      this.modal.AiShow = true;
      this.modal.AiTenData = [];
      this.modal.loading = true;
      this.checkDevice = obj;
      this.getDeviceApi();
    },
    getDeviceApi() {
      this.$api.Report.getRecordFroStatistics(
        { content: { siteDeviceId: this.checkDevice.id, startDate: this.checkDevice.startDate, endDate: this.checkDevice.endDate } },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          for (let i = 0, length = data.length; i < length; i++) {
            data[i].intTime = this.formatMinute(data[i].intTime);
          }
          this.modal.loading = false;
          this.modal.AiTenData = data;
          this.chartDraw();
        } else {
          this.$Notice.warning({
            title: "获取十条电流值失败",
            desc: res.message || "请联系管理员",
          });
        }
      });
    },
    chartDraw() {
      this.myChart = echarts.init(this.$refs.valueChartRef);
      let option = this.getOption();
      this.myChart.setOption(option);
    },
    getOption() {
      //this.checkDevice.limitValue
      console.log(this.checkDevice)
      return {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.modal.AiTenData.map(item => item.intTime)
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 65,
            end: 100
          },
          {
            type: 'inside',
            realtime: true,
            start: 65,
            end: 100
          }
        ],
        tooltip: {
          trigger: 'axis',
          formatter: (parmas) => {
            let date = parmas[0].axisValue;
            let deviceName = parmas[0].seriesName;
            let value = parmas[0].value;
            let unit = this.checkDevice.unit;
            return `${date}<br />
            ${parmas[0].marker}${deviceName}:${value}${unit}`
          }
        },
        series: [
          {
            name: this.checkDevice.name,
            data: this.modal.AiTenData.map(item => item.siteDeviceAi),
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,237,243,0.80)' },
                { offset: 1, color: 'rgba(142,230,255,0.00)' }
              ]),
            },
            lineStyle: {
              color: "rgba(0,237,243,1)"
            },
            markLine: {
              silent: true,
              data: [{
                yAxis: this.checkDevice.limitValue || 0  // 这里设置你的限值  
              }]
            }
          }
        ]
      }
    },
    // 获取设备类型及状态对应设备图片
    getActivatedCharcoal() {
      this.$api.Deploy.getActivatedCharcoalList(
        {
          content: { mn: this.nowSite.mn },
          paging: false,
        },
        ["uuid", "company"]
      )
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            for (let i = 0, length = data.length; i < length; i++) {
              data[i].reloadTime = timeStamp(data[i].reloadTime);
            }
            this.activatedCharcoal = data;
          }
        })
        .catch();
    },
    // 告警信息鼠标移入
    warnOver(e) { },
    // 告警信息鼠标移出
    warnOut() { },
    // 设备工艺图移入显示
    showAiDiv(item) {
      // 更新设备时间
      if (item.createDateNew) {
        item.createAgo = timeLength(item.createDateNew);
      }
      this.showAiId = item.id;
    },
    // 设备工艺图移出影藏
    hideAiDiv() {
      this.showAiId = null;
    },
    // 活性炭工艺图移入显示
    showACDiv(item) {
      this.showACId = item.id;
    },
    // 活性炭工艺图移出影藏
    hideACDiv() {
      this.showACId = null;
    },
    // 电流值更新
    webSocket() {
      if (this.isLocalAddress(window.location.hostname)) {
        return;
      }
      const wsProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
      const wsHost = window.location.hostname + (window.location.port ? `:${window.location.port}` : '');
      const wsPath = '/api/webSocket';
      const wsURL = wsProtocol + wsHost + wsPath;
      console.log(wsURL);
      let siteMn = this.nowSite.mn;
      let socket = new MyWebSocket({
        url: wsURL,
        siteMn: siteMn,
        onopen: function () {
          socket.send("subscrip", {
            siteDeviceState: {
              siteMn: socket.siteMn,
            },
          });
        },
      });
      window.socket = socket;
      socket.register("siteDeviceState", (data) => {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.deviceList[i].id == data.content.siteDeviceId) {
            this.deviceList[i].siteDeviceAi =
              data.content.siteDeviceAi.toFixed(2); // 更新电流值
            // 更新图片状态
            let siteDeviceState = data.content.siteDeviceState;
            this.deviceList[i].createAgo = timeLength(data.content.createDate);
            this.deviceList[i].statusLsit = data.content.siteDeviceStateNames;
            this.deviceList[i].createDateNew = data.content.createDate;
            if (!this.deviceList[i].deviceStateImageList) return;
            this.deviceList[i].deviceStateImageList.map((res) => {
              if (res.states == siteDeviceState) {
                this.deviceList[i].statusImg = res.url;
              }
            });
            // 更新时间
            break;
          }
        }
      });
      socket.recontent();
      this.socket = socket;
    },
    formatMinute(intTime) {
      // 将整数转换为字符串  
      const strTime = String(intTime);
      // 格式化日期和时间  
      const formattedDateTime = `${strTime.slice(0, 4)}年${strTime.slice(4, 6)}月${strTime.slice(6, 8)}日${strTime.slice(8, 10)}时${strTime.slice(10, 12)}分`;
      // 输出格式化后的日期和时间  
      //console.log(formattedDateTime); // 输出 "2023年07月03日12时30分"
      return formattedDateTime;
    },
    isLocalAddress(hostname) {
      return hostname === 'localhost' || hostname === '127.0.0.1' ||
        /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
        /^172\.(1[6-9]|2[0-9]|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);
    },
    jsMul(num1, num2) {
      var m = 0, s1 = num1.toString(), s2 = num2.toString();
      try { m += s1.split(".")[1].length } catch (e) { };
      try { m += s2.split(".")[1].length } catch (e) { };
      return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },
    mergedContent(item) {
      const values = item.contentTypeValue.split('||');
      return item.contentTypeName.replace(/%s/g, () => values.shift());
    },
  },

};
</script>